// src/apiService.js

import axiosClient from './axiosClient'; // Import the Axios client

// Function to fetch addons
const getAddOns = async () => {
    try {
        const response = await axiosClient.get('/add-on'); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching addons:', error);
        throw error; // Rethrow the error for further handling
    }
};

const getAddOnDetail = async (id) => {
    try {
        const response = await axiosClient.get(`/add-on/${id}`); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching addons:', error);
        throw error; // Rethrow the error for further handling
    }
};

const createAddOn = async (formData) => {
    try {
        const response = await axiosClient.post('/add-on', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error creating addon:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// DELETE addon by ID
const deleteAddOn = async (id) => {
    try {
        const response = await axiosClient.delete(`/add-on/${id}`);
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error deleting addon:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// PATCH addon by ID
const updateAddOn = async (id, formData) => {
    try {
        const response = await axiosClient.patch(`/add-on/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating addon:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// Export the function
export { getAddOns, deleteAddOn, createAddOn, updateAddOn, getAddOnDetail };
